import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { withLDConsumer as featureFlagClient } from 'launchdarkly-react-client-sdk';

import { currentPaymentMethod } from '../../modules/payment/slice';
import { paymentIdList } from '../../helpers/constants';
import CreditCardApp from '../../modules/credit-card-app/containers';
import DataContext from '../../store/dataContext';

import PaypalCheckout from '../PaymentMethods/PaypalCheckout';
import AmazonCheckout from '../PaymentMethods/AmazonCheckout';
import GoogleCheckout from '../PaymentMethods/GoogleCheckout';
import VenmoCheckout from '../PaymentMethods/VenmoCheckout';
import DefaultView from '../PaymentMethods/DefaultView';

const PaymentMethodSelected = ({ setOrderSubmitting, flags }) => {
  const { moveToPlatform } = useContext(DataContext);
  const selectedMethod = useSelector(currentPaymentMethod);
  const resultingMarkup = [];

  if (
    !flags['disable-paypal'] &&
    (selectedMethod === paymentIdList.PAYPAL || (selectedMethod === paymentIdList.PAYLATER && !moveToPlatform.paylater))
  ) {
    resultingMarkup.push(
      <PaypalCheckout flags={flags} setOrderSubmitting={setOrderSubmitting} key={paymentIdList.PAYPAL} />,
    );
  } else if (!flags['disable-venmo'] && selectedMethod === paymentIdList.VENMO) {
    resultingMarkup.push(
      <VenmoCheckout flags={flags} setOrderSubmitting={setOrderSubmitting} key={paymentIdList.VENMO} />,
    );
  } else if (!flags['disable-amazon'] && selectedMethod === paymentIdList.AMAZONPAY) {
    resultingMarkup.push(
      <AmazonCheckout flags={flags} setOrderSubmitting={setOrderSubmitting} key={paymentIdList.AMAZONPAY} />,
    );
  } else if (!flags['disable-google'] && selectedMethod === paymentIdList.GOOGLEPAY) {
    resultingMarkup.push(
      <GoogleCheckout flags={flags} setOrderSubmitting={setOrderSubmitting} key={paymentIdList.GOOGLEPAY} />,
    );
  } else {
    resultingMarkup.push(
      <div style={{ display: selectedMethod === paymentIdList.CREDIT_CARD ? 'none' : 'block' }} key="default-view">
        <DefaultView flags={flags} />
      </div>,
    );
  }

  resultingMarkup.push(
    <div
      style={{ display: selectedMethod === paymentIdList.CREDIT_CARD ? 'block' : 'none' }}
      key={paymentIdList.CREDIT_CARD}
    >
      <CreditCardApp flags={flags} />
    </div>,
  );

  return resultingMarkup.map(item => item);
};

PaymentMethodSelected.propTypes = {
  setOrderSubmitting: PropTypes.func.isRequired,
  flags: PropTypes.shape({
    'disable-paypal': PropTypes.bool,
    'disable-amazon': PropTypes.bool,
    'disable-venmo': PropTypes.bool,
  }),
};

export default featureFlagClient()(PaymentMethodSelected);
